'use strict';

module.exports = /*@ngInject*/ ['rx', 'ConfigurationResourceService', function ProjectConfigurationService(rx, ConfigurationResourceService) {

  var serviceAPI = {
    getProjectConfiguration: getProjectConfiguration
  };
  
  function getProjectConfiguration(projectId) {
    return rx.Observable.fromPromise(ConfigurationResourceService.noc().get({
      projectId: projectId
    }).$promise); 
  }

  return serviceAPI;

}];